<div class="table-responsive">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>#</th>
                <th>{{ 'name' | translate }}</th>
                <th>{{ 'floor' | translate }}</th>
                <th>{{ 'options' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let office of offices; let i = index" [ngClass]="{'table-warning': office.isChanged}">
                <td class="position-relative">{{ i + 1 }}
                    <div [id]="'office_' + office.id" class="anchor-target" style="position: absolute; top: -70px;">
                    </div>
                </td>
                <td>{{ office.name }}</td>
                <td>{{ office.floor }}</td>
                <td>
                    <div class="row">
                        <button class="btn btn-info btn-circle btn-sm mx-1 mb-1"
                            (click)="router.navigate(['office', office.id])"
                            matTooltip="{{ 'edit' | translate }}" tooltipClass="tooltip-info">
                            <i class="fas fa-fw fa-edit"></i>
                        </button>
                        <button
                            (click)="selectedOfficeId = office.id"
                            class="btn btn-danger btn-circle btn-sm mx-1 mb-1"
                            matTooltip="{{ 'delete' | translate }}" tooltipClass="tooltip-danger"
                            data-toggle="modal" data-target="#deleteModal3">
                            <i class="fas fa-fw fa-trash"></i>
                        </button>
                    </div>
                </td>
                </tr>
        </tbody>
    </table>
</div>

<div class="modal fade" id="deleteModal3" tabindex="-1" role="dialog" aria-hidden="true">
    <app-delete-modal [info]="'delete-confirmation'" [confirm]="'delete'" (confirmed)="onDeleteConfirm($event)"></app-delete-modal>
</div>
